import { SharedModule } from './../shared/shared.module';
import { NgModule } from '@angular/core';
import { EmailTemplateListComponent } from './email-template-list/email-template-list.component';
import { EmailTemplateEditComponent } from './email-template-edit/email-template-edit.component';

@NgModule({
  declarations: [
    EmailTemplateListComponent,
    EmailTemplateEditComponent
  ],
  imports: [
    SharedModule
  ]
})
export class EmailTemplateModule { }
